import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
import usePermissions from "hooks/usePermissions";
const useCollectionViewCondition = () => {
  const {
    data: { valid: isValidLicense },
    isInitialLoading: isLoadingLicense
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  const { isPermitted } = usePermissions();
  if (isLoadingLicense) {
    return false;
  }
  return isValidLicense && isPermitted("collections:read");
};
export default useCollectionViewCondition;
